export default "__VITE_ASSET__C3l2Pv$h__"